import mainStyles from "style/main.module.scss";
type Props = {
  className?: string;
  small?: boolean;
};

export const RedDotIcon: React.FC<Props> = ({ className, small = false }) => {
  return (
    <div
      className={small ? mainStyles.redCircleSmall : mainStyles.redCircle}
    ></div>
  );
};
